export default ({request}) => ({
  orderInspectionBatchListApi(data = {}) {
    return request({
      url: '/factory/order/inspection/batch/list',
      method: 'post',
      data,
    })
  },
  orderInspectionBatchSaveApi(data = {}) {
    return request({
      url: '/factory/order/inspection/batch/save',
      method: 'post',
      data,
    })
  },
  orderInspectionBatchsDelApi(data = {}) {
    return request({
      url: '/factory/order/inspection/batch/del',
      method: 'post',
      data,
    })
  },
})
